import { i18n } from '../../i18n'

const state = {}

const getters = {
  navigationItems(state, getters) {        
    const items = []
    items.push({
      title: i18n.t('equipment.mainInfo.title'),
      icon: 'settings_applications',
      routerLinkData: 'mainInfo',
      class: 'hidden-sm-and-down'
    })
    if (getters.equipmentData.HasUsageStats) {
      items.push({
        title: i18n.t('navigation.usageStats'),
        icon: 'all_out',
        routerLinkData: 'usageStats',
        class: 'hidden-sm-and-down'
      })
    }
    if (getters.passportWorkRequests && getters.passportWorkRequests.length) {
      items.push({
        title: i18n.t('equipment.workRequests.title'),
        icon: 'build',
        routerLinkData: 'workRequests',
        class: 'hidden-sm-and-down'
      })
    }
    if (getters.equipmentData.CanAddWorkRequests) {
      items.push({
        title: i18n.t('navigation.addWorkRequest'),
        icon: 'note_add',
        routerLinkData: 'addWorkRequest',
        class: 'hidden-sm-and-down'
      })
    }
    if ((getters.equipmentData.ConditionParameters
            && getters.equipmentData.ConditionParameters.length)
            || (getters.equipmentData.MaintenanceNorms
                && getters.equipmentData.MaintenanceNorms.length)) {
      items.push({
        title: i18n.t('equipment.strategies.title'),
        icon: 'list_alt',
        routerLinkData: 'strategies',
        class: 'hidden-sm-and-down'
      })
    }
    if (getters.equipmentData.Inspections && getters.equipmentData.Inspections.length) {
      items.push({
        title: i18n.t('equipment.inspections.title'),
        icon: 'check_box',
        routerLinkData: 'inspections',
        class: 'hidden-sm-and-down'
      })
    }
    if (getters.equipmentData.Resources && getters.equipmentData.Resources.length) {
      items.push({
        title: i18n.t('equipment.resources.title'),
        icon: 'widgets',
        routerLinkData: 'resources',
        class: 'hidden-sm-and-down'
      })
    }
    return items
  }
}

const actions = {}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}